import { render, staticRenderFns } from "./CopyLink.vue?vue&type=template&id=53c08e90&scoped=true&"
import script from "./CopyLink.vue?vue&type=script&lang=js&"
export * from "./CopyLink.vue?vue&type=script&lang=js&"
import style0 from "./CopyLink.vue?vue&type=style&index=0&id=53c08e90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53c08e90",
  null
  
)

export default component.exports